import { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import { Skill } from './types';
import RingChart from './RingChart';
import styles from './Skills.module.scss';

interface BarStyle extends CSSProperties {
  '--level': number;
  '--delay': string;
}

const CoreWideCard = ({ skill }: { skill: Skill }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className={styles.wideHeader}>
        <div>
          <p className={styles.coreTag}>{t('skills.coreTag')}</p>
          <h3 className={styles.name}>{skill.name}</h3>
        </div>
        <RingChart level={skill.level} radius={26} />
      </div>
      <ul className={styles.subSkillList}>
        {skill.subSkills?.map((sub, i) => {
          const barStyle: BarStyle = { '--level': sub.level, '--delay': `${i * 0.09}s` };
          return (
            <li key={sub.id} className={styles.subSkill}>
              <div className={styles.subSkillMeta}>
                <span className={styles.subSkillName}>{sub.name}</span>
                <span className={styles.subSkillPct}>{sub.level}%</span>
              </div>
              <div className={styles.barTrack}>
                <div className={styles.barFill} style={barStyle} />
              </div>
            </li>
          );
        })}
      </ul>
    </>
  );
};

export default CoreWideCard;
